import { render, staticRenderFns } from "./InteractionTeam.vue?vue&type=template&id=5bdf53a6&scoped=true&"
import script from "./InteractionTeam.vue?vue&type=script&lang=ts&"
export * from "./InteractionTeam.vue?vue&type=script&lang=ts&"
import style0 from "./InteractionTeam.vue?vue&type=style&index=0&id=5bdf53a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf53a6",
  null
  
)

export default component.exports